import {AccessibilityUnitLevel} from "../../../../../models/AccessibilityUnits";
import {Property} from "../../../../../models/Property";
import React, {FC} from "react";
import FloorItem from "./FloorItem";
import styled from "styled-components/macro";
import {Divider as MuiDivider} from "@material-ui/core";
import {spacing} from "@material-ui/system";

const Divider = styled(MuiDivider)(spacing);

type PropsType = {
  floors: number,
  handleClick: () => void,
  levels: AccessibilityUnitLevel[],
  handleDelete: (index: number) => void,
  property: Property,
  handleChangeCounter: (field: string, value: number, index: number) => void,
  isQuantityAvailable: boolean
  isFloorAvailable: boolean
}

const FloorList: FC<PropsType> = ({
  floors,
  handleClick,
  levels,
  handleDelete,
  property,
  handleChangeCounter,
  isQuantityAvailable,
  isFloorAvailable
}) => {
  let layout = [];

  for (let i = 0; i < floors; i++) {
    layout.push(
      <FloorItem
        key={i}
        index={i}
        handleClick={handleClick}
        levels={levels}
        handleDelete={handleDelete}
        property={property}
        handleChangeCounter={handleChangeCounter}
        isQuantityAvailable={isQuantityAvailable}
        isFloorAvailable={isFloorAvailable}
      />
    );
  }
  return (
    <React.Fragment>
      {/*<Divider my={3} />*/}
      {layout}
    </React.Fragment>
  );
}

export default FloorList